import React, { PureComponent } from 'react';
import InputGroup from './inputGroup';

type Props = {
  label: {
    path: string,
    using: Object,
  },
  value: string | number,
  onChange: Function,
  changeHandler: Function,
};

export default class InputAge extends PureComponent<Props> {
  static defaultProps = {
    label: { path: 'common.label.age' },
    value: null,
    onChange: () => {},
    changeHandler: () => {},
  };

  onChange = (e) => {
    const age = parseInt(e.target.value, 10);
    if (e.target.value.length === 0 || (age > 0 && age < 201)) {
      this.props.onChange(e.target.value);
      this.props.changeHandler(age);
    }
  };

  render() {
    // changeHandler needs to be pulled off or react complains about DOM element property
    const { changeHandler, ...props } = this.props;
    return (
      <div style={{ maxWidth: 100 }}>
        <InputGroup {...props} suppressError onChange={this.onChange} type="tel" />
      </div>
    );
  }
}
